import { FC, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { i18n } from '../../../translate/i18n'
import { Button } from '../../../components/Button/Button'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import { ModularDataTable } from "../../../components/ModularDataTable"
import { ModalDelete } from '../../../components/Modals/General/ModalDelete/ModalDelete'
import useModals from '../../../hooks/useModals'
import { useLojasAgregador } from './factory/useLojasAgregador'
import { createColumns } from './factory/generateColumns'
import { createActions } from './factory/actionsFactory'



const LojasContent: FC = () => {
  const navigate = useNavigate()
  const { showDeleteModal } = useModals()
  const [deleteId, setDeleteId] = useState<number>(0)
  const {
    lojasAgregador,
    updateLojaAgregador,
    deleteLojasAgregador,
    getLojasAgregador,
    handleSortingChange,
    tableLoading,
    pagination,
    sorting,
    handleDataChange,
    handlePaginationChange,
  } = useLojasAgregador()

  const columns = useMemo(() => createColumns({ switchStatus: switchStatus }), [])

  async function switchStatus({ endpoint, Id, status }: { endpoint: string; Id: number; status: boolean }) {

    if (Id !== -1) {
      await updateLojaAgregador(Id, { status: status } as any)
    }
  }

  const actions = useMemo(() => createActions({
    navigate,
    showDeleteModal,
    setDeleteId,
  }), [])

  useEffect(() => {
    getLojasAgregador()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])





  return (
    <>
      <div className='row g-5 gx-xxl-12'>
        <div className='card card-xxl-stretch mb-5 mb-xl-12'>
          <div className='card-header py-5 d-flex flex-column'>
            <div className='d-flex justify-content-between'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Lojas</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Aqui estão listadas as lojas do agregador juntamente com suas respectivas ações.
                  </span>
              </h3>

              <div className='card-toolbar'>
                <Button
                  text='Cadastrar Lojas no Agregador'
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/stores/criar')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>

           <div className='card-body'>
              <ModularDataTable
                data={lojasAgregador}
                columns={columns}
                actions={actions}
                pagination={pagination}
                onPaginationChange={handlePaginationChange}
                sorting={sorting}
                onSortingChange={handleSortingChange}
                onDataChange={handleDataChange}
                searchable={true}
                searchPlaceholder='Pesquisar página...'
                loading={tableLoading}
                selectable={false}
                striped={false}
                hover={false}
                size='md'
                className='table-row-bordered table-row-gray-200'
                alterColumns
                persistPageKey='locais_agregador'
                persistContextKey='default'
              />
            </div>
          </div>
        </div>
      </div>

      <ModalDelete confirmAction={() => deleteLojasAgregador(deleteId)} text='delete_item' />
    </>
  )
}

const LojasAgregador: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[{ title: `${i18n.t(`permissions.stores`)}`, path: '/lojas', isActive: false }]}
      >
        {i18n.t(`permissions.stores`)}
      </PageTitle>
      <LojasContent />
    </>
  )
}

export { LojasAgregador }
